export default __webpack_public_path__ + "static/modal-b1afcafcd60abaf2ef750db34a3d2d20.png";